export const TEST_EVENT_FROM_SOCKET = 'TEST_EVENT_FROM_SOCKET'
export const CONNECT_TO_SOCKET_EVENT = 'CONNECT_TO_SOCKET_EVENT'
export const DISCONNECT_FROM_SOCKET_EVENT = 'DISCONNECT_FROM_SOCKET_EVENT'

export function fireTestEventFromSocket(payload: unknown) {
  return {
    type: TEST_EVENT_FROM_SOCKET,
    payload: { payload },
  }
}

export interface SocketListenerPayload {
  eventType: string
  actionType: string
}

export function connectToSocketEvent(payload: SocketListenerPayload) {
  return {
    type: CONNECT_TO_SOCKET_EVENT,
    payload,
  }
}

export function disconnectFromSocketEvent(payload: SocketListenerPayload) {
  return {
    type: DISCONNECT_FROM_SOCKET_EVENT,
    payload,
  }
}
